<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17ZKe0h/tc-custom/9781780106915.jpg?1736610486559" alt="This image is the cover for the book Heirs and Assigns, The Herbert Reardon Historical Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heirs and Assigns, The Herbert Reardon Historical Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Detective Inspector Herbert Reardon’s debut mystery “will delight fans of the TV series <i>Downton Abbey” </i>(<i>Library Journal</i>, starred review).</b><br/>  <br/> November, 1928. Family and friends have gathered at the Shropshire country home of Penrose Llewellyn to celebrate the retired wealthy businessman’s 60th birthday. But the morning after what should have been a convivial supper party, their host is found dead in his bed—and the circumstances look decidedly suspicious.<br/>  <br/> As he questions the victim’s nearest and dearest, DI Herbert Reardon discovers there are several longstanding secrets lurking amongst the Llewellyn clan—and he is convinced that not everyone is telling him the truth, or at least not the whole truth. Those who stand to inherit most from Pen Llewellyn’s will—if it can be found—are under the strongest suspicion, and among them hides a ruthless killer.<br/>  <br/> “Readers will be as keen as the inspector to see how the case develops.” —<i>Publishers Weekly</i><br/>  <br/> “This delightful British country-house mystery features a clever plot, captivating characters, and authentic period detail.” —<i>Booklist</i><br/>  <br/> “Plenty of suspects and unexpected twists.” —<i>Kirkus Reviews</i><br/>  <br/> “Will delight fans of the TV series <i>Downton Abbey</i> and authors Simon Brett and Kate Kingsbury” —<i>Library Journal</i> (starred review)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marjorie Eccles
      </h2>
      
      <p class="authorDescription body article">Marjorie Eccles was born in Yorkshire and has since spent some time on the Northumbrian coast. Marjorie has written mainly crime novels, but also some romantic fiction. She is the author of the ‘Gill Mayo’ mystery series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e64322b